import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {

	return {
		modalRoot: {
			borderRadius: "2rem"
		},
		modalBody: {
			position      : "relative",
			display       : "flex",
			height        : "100%",
			borderRadius  : "2rem",
			background    : `${ theme.other.paletteNew.darkModeInclinedBlack2 } !important`,
			flexDirection : "row",

			[rooterMediaQuery.tablet]: {
				padding: props?.alreadyPlus ? "0.1rem" : "2rem"
			},

			[rooterMediaQuery.mobile]: {
				height        : "fit-content",
				flexDirection : "column"
			}
		},
		modalInner: {
			[rooterMediaQuery.mobile]: {
				overflow: "scroll"
			}
		},
		modalContent: {
			background   : `${ theme.other.paletteNew.darkModeInclinedBlack2 } !important`,
			borderRadius : "2rem",
			flexBasis    : props?.alreadyPlus ? "min(450px, 100%)" : "min(1000px, 100%)",
			height       : "min(800px, 80vh)",
			transform    : "scale(1)",

			[rooterMediaQuery.desktop]: {
				padding: props?.alreadyPlus ? "0.1rem" : "2rem"
			},

			[rooterMediaQuery.mobile]: {
				height       : "100dvh",
				borderRadius : "0rem !important"
			},

			padding  : "0.2rem",
			overflow : "hidden !important"
		},
		proBorder: {

			":after": {
				content   : "' '",
				position  : "absolute",
				left      : "50%",
				top       : "50%",
				height    : "1200px",
				width     : "1200px",
				zIndex    : "-1",
				transform : "translate(-50%, -50%)",
				animation : "rotateProChip 10s linear infinite",

				"@keyframes rotateProChip": {
					"0%": {
						transform: "translate(-50%, -50%) rotate(0deg)"
					},
					"100%": {
						transform: "translate(-50%, -50%) rotate(360deg)"
					}
				}
			}
		},
		errorTitle: {
			fontWeight : "500",
			padding    : "1rem"
		},
		errorSubtitle: {
			color: theme.other.colors.text.secondary
		},
		errorModalBody: {
			padding: "2rem 3rem"
		},
		errorModalClose: {
			position : "absolute",
			right    : "0",
			top      : "0",
			margin   : "1.5rem",
			cursor   : "pointer"
		},
		errorModalContent: {
			flexBasis       : "auto",
			backgroundColor : theme.other.colors.dialog.secondary
		},
		qrImage: {
			height       : "120px",
			width        : "120px",
			margin       : "1rem",
			marginTop    : "2rem",
			borderRadius : "1rem"
		},
		errorDrawerBody: {
			background   : theme.other.paletteNew.darkModeInclinedBlack2,
			borderRadius : "1rem 1rem 0 0"
		},
		errorDrawerContent: {
			borderRadius : "1rem 1rem 0 0",
			overflow     : "hidden",
			padding      : "2rem",
			height       : "fit-content",
			position     : "relative"
		},
		downloadAppBtn: {
			marginTop    : "2rem",
			marginBottom : "1rem"
		},

		modalRootNew: {
			borderRadius : "2rem",
			width        : "498px !important" // 450px + 3rem (48px) = 498px
		},
		modalBodyNew: {
			position      : "relative",
			display       : "flex",
			flexDirection : "column",
			background    : `${ theme.other.paletteNew.darkModeInclinedBlack2 } !important`,
			maxWidth      : "498px", // 450px + 3rem (48px) = 498px
			overflowX     : "hidden",

			[rooterMediaQuery.tablet]: {
				padding: props?.alreadyPlus ? "0.1rem" : "2rem"
			},

			[rooterMediaQuery.mobile]: {
				height        : "fit-content",
				flexDirection : "column",
				maxWidth      : "100%"
			}
		},
		modalInnerNew: {
		},
		modalInnerWrapper: {
			maxWidth      : "100%",
			overflowX     : "hidden",
			display       : "flex",
			flexDirection : "column",
			gap           : "2rem",
			height        : "100%",
			maxHeight     : "100%"
		},
		modalContentNew: {
			background    : `${ theme.other.paletteNew.darkModeInclinedBlack2 } !important`,
			flexBasis     : "auto",
			height        : "min(800px, 80vh)",
			maxHeight     : "80vh",
			width         : "49.8rem !important",
			maxWidth      : "49.8rem !important", // 450px + 3rem (48px) = 498px
			overflowY     : "hidden",
			overflowX     : "hidden",
			display       : "flex",
			flexDirection : "column",

			[rooterMediaQuery.desktop]: {
				padding: "0" /*  props?.alreadyPlus ? "0.1rem" : "2rem" */
			},

			[rooterMediaQuery.mobile]: {
				height       : "fit-content",
				maxHeight    : "100dvh",
				borderRadius : "0rem !important",
				maxWidth     : "100%"
			},

			padding: "0.2rem"
		}
	};
} );
